import React from 'react';
import { useTranslation } from 'react-i18next';
import { changeAmbientLanguage, SUPPORTED_LOCALES } from './index';

/**
 * Seletor de idioma da interface (pt-BR / en).
 * @param {'select' | 'inline'} [variant]
 */
export default function LanguageSwitcher({ variant = 'select', className = '' }) {
  const { t, i18n } = useTranslation('common');
  const current = i18n.resolvedLanguage || i18n.language || 'pt-BR';

  const onChange = (event) => {
    changeAmbientLanguage(event.target.value);
  };

  if (variant === 'inline') {
    return (
      <div className={`flex items-center gap-2 ${className}`.trim()} role="group" aria-label={t('language')}>
        {SUPPORTED_LOCALES.map((lng) => (
          <button
            key={lng}
            type="button"
            onClick={() => changeAmbientLanguage(lng)}
            className={`rounded-md px-2 py-1 text-xs font-medium ${
              current === lng
                ? 'bg-primary-100 text-primary-900'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            {lng === 'pt-BR' ? 'PT' : 'EN'}
          </button>
        ))}
      </div>
    );
  }

  return (
    <select
      className={`form-select ${className}`.trim()}
      value={current.startsWith('en') ? 'en' : 'pt-BR'}
      onChange={onChange}
      aria-label={t('language')}
    >
      <option value="pt-BR">{t('languagePt')}</option>
      <option value="en">{t('languageEn')}</option>
    </select>
  );
}
